import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Footer } from "../../components/Footer/Footer";
import PerformanceCard from "./components/PerformanceCard";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

const OBJECT_IDS = {
  USER_NAME: "JnrpkD",
  SELL_IN: "dnTjju",
  REBATE: "XAxfy",
  REBATE_PERCENT: "vDFpQjj",
  RANKING: "tjQzgaU",
};

const MetricsCards = ({ sellinValue, rebateValue, rebatePercentValue, app }) => (
  <Grid
    container
    flexDirection="row"
    justifyContent="space-between"
    className="container-bigNumbers"
    spacing={0.5}
  >
    <Grid item xs={12} sm={4}>
      <Card
        app={app}
        header={{
          hardTitle: "Sell in",
        }}
        className="card-bigNumbers"
      >
        <h3>{sellinValue}</h3>
      </Card>
    </Grid>

    <Grid item xs={12} sm={4}>
      <Card
        app={app}
        header={{
          hardTitle: "Rebate",
        }}
        className="card-bigNumbers"
      >
        <h3 className="rebate">{rebateValue}</h3>
      </Card>
    </Grid>

    <Grid item xs={12} sm={4}>
      <Card
        app={app}
        header={{
          hardTitle: "% Rebate",
        }}
        className="card-bigNumbers"
      >
        <h3 className="rebate">{rebatePercentValue}</h3>
      </Card>
    </Grid>
  </Grid>
);

const WelcomeCard = ({ nameUser }) => (
  <Card className="container-card-title">
    <h1 className="title">Olá, {nameUser}</h1>
    <p className="text">
      Nesta tela você consegue ter uma visão geral de todos os KPIs. Para
      analisar os detalhes de cada indicador, utilize o menu lateral.
    </p>
  </Card>
);

function OverviewDesktop({ app }) {
  const { selections } = useSelections();
  const [nameUser, setNameUser] = useState("");
  const [sellinValue, setSellinValue] = useState();
  const [rebateValue, setRebateValue] = useState();
  const [rebatePercentValue, setRebatePercentValue] = useState();
  const { isLoading } = useOverviewData(app);

  const getNameUser = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          setNameUser(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  const getvalueSellIn = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          setSellinValue(value);
        } catch (error) {
          console.error("Erro ao buscar valor de Sell in:", error);
        }
      }
    },
    [app]
  );

  const getvalueRebate = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          setRebateValue(value);
        } catch (error) {
          console.error("Erro ao buscar valor de Rebate:", error);
        }
      }
    },
    [app]
  );

  const getvalueRebatePercent = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          setRebatePercentValue(value);
        } catch (error) {
          console.error("Erro ao buscar valor de % Rebate:", error);
        }
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getNameUser(OBJECT_IDS.USER_NAME);
      getvalueSellIn(OBJECT_IDS.SELL_IN);
      getvalueRebate(OBJECT_IDS.REBATE);
      getvalueRebatePercent(OBJECT_IDS.REBATE_PERCENT);
    }
  }, [app, getNameUser, getvalueRebate, getvalueRebatePercent, getvalueSellIn, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection="column"
            justifyContent="flex-start"
            rowGap={2}
          >
            {isLoading ? (
              <>
                <Grid item>
                  <OverviewCardSkeleton variant="welcome" />
                </Grid>

                <Grid item>
                  <Grid
                    container
                    flexDirection="row"
                    justifyContent="space-between"
                    className="container-bigNumbers"
                    spacing={0.5}
                  >
                    <Grid item xs={4}>
                      <OverviewCardSkeleton variant="metrics" />
                    </Grid>
                    <Grid item xs={4}>
                      <OverviewCardSkeleton variant="metrics" />
                    </Grid>
                    <Grid item xs={4}>
                      <OverviewCardSkeleton variant="metrics" />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  container
                  className="container-tables-tops"
                  spacing={2}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <Grid item xs={12} sm={7.8}>
                    <OverviewCardSkeleton variant="performance" />
                  </Grid>
                  <Grid item xs={12} sm={4.1}>
                    <OverviewCardSkeleton variant="ranking" />
                  </Grid>
                </Grid>
              </>
            ) : (
              <>
                <Grid item>
                  <WelcomeCard nameUser={nameUser} />
                </Grid>

                <Grid item>
                  <MetricsCards
                    sellinValue={sellinValue}
                    rebateValue={rebateValue}
                    rebatePercentValue={rebatePercentValue}
                    app={app}
                  />
                </Grid>

                <Grid item container className="container-tables-tops">
                  <PerformanceCard app={app} />

                  <Card
                    app={app}
                    header={{
                      hardTitle: "Ranking de Positivação",
                    }}
                    className="card-menor"
                  >
                    <NativeObject
                      app={app}
                      key={OBJECT_IDS.RANKING}
                      reference={{ id: OBJECT_IDS.RANKING }}
                      style={{
                        width: "100%",
                        height: "530px",
                      }}
                    />
                  </Card>
                </Grid>

                <Footer app={app} />
              </>
            )}
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

OverviewDesktop.propTypes = {
  app: PropTypes.object,
};

MetricsCards.propTypes = {
  sellinValue: PropTypes.any,
  rebateValue: PropTypes.any,
  rebatePercentValue: PropTypes.any,
  app: PropTypes.object.isRequired,
};

WelcomeCard.propTypes = {
  nameUser: PropTypes.string.isRequired,
};

export default OverviewDesktop;
